import { FC, ReactNode } from 'react';
import { Page, PageTitle } from '@edikk-edikk/country-layout-black';
import HTMLReactParser from 'html-react-parser';
import { MetaData } from '#page/components';
import { usePageContext } from '#page/hooks';
import customPageCss from '#srcCssModules/custom-page.module.scss';

const Content: FC = () => {
  const { page } = usePageContext();

  const renderDescription = (): ReactNode => {
    if (!page.description) {
      return null;
    }
    return HTMLReactParser(page.description);
  };

  return (
    <>
      <MetaData />
      <Page>
        <PageTitle title={page.title} />
        <div className={customPageCss.customPage}>
          {renderDescription()}
        </div>
      </Page>
    </>
  );
};

export { Content };
